__turbopack_context__.v({
  "contacts": "contacts-block-module-scss-module__qweA8W__contacts",
  "contacts__contact-block": "contacts-block-module-scss-module__qweA8W__contacts__contact-block",
  "contacts__contact-data": "contacts-block-module-scss-module__qweA8W__contacts__contact-data",
  "contacts__region-title": "contacts-block-module-scss-module__qweA8W__contacts__region-title",
});
